import React from 'react';
import { Button } from '@mui/material';

export const positionChangeRequestColumns = (onDecision, disabled) => [
    { field: 'employeeName', headerName: 'Employee', minWidth: 170, flex: 1,
        valueGetter: ({ row }) => `${row.employee.firstName} ${row.employee.lastName}` },
    { field: 'email', headerName: 'Email', minWidth: 210, flex: 1,
        valueGetter: ({ row }) => row.employee.email },
    { field: 'currentPosition', headerName: 'Current position', minWidth: 180, flex: 1,
        valueFormatter: ({ value }) => value || 'Not set' },
    { field: 'requestedPosition', headerName: 'Requested position', minWidth: 180, flex: 1 },
    { field: 'requestedAtUtc', headerName: 'Requested', minWidth: 185,
        valueFormatter: ({ value }) => value ? new Date(value).toLocaleString() : '' },
    ...['approve', 'reject'].map((action) => ({
        field: action, headerName: action === 'approve' ? 'Approve' : 'Reject', width: 105,
        renderCell: ({ row }) => <Button disabled={disabled}
            aria-label={`${action === 'approve' ? 'Approve' : 'Reject'} position change for ${row.employee.firstName} ${row.employee.lastName}`}
            onClick={() => onDecision(row, action)}>
            {action === 'approve' ? 'Approve' : 'Reject'}
        </Button>,
    })),
].map((column) => ({ ...column, sortable: false, filterable: false }));
